import { render, staticRenderFns } from "./ShareRecordList.vue?vue&type=template&id=33f5ae0a&scoped=true"
import script from "./ShareRecordList.vue?vue&type=script&lang=js"
export * from "./ShareRecordList.vue?vue&type=script&lang=js"
import style0 from "./ShareRecordList.vue?vue&type=style&index=0&id=33f5ae0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5ae0a",
  null
  
)

export default component.exports